var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerElement",style:(_vm.style),attrs:{"className":"vue-monaco-editor-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }